/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAdminUserWalletDetailPageListRespVo } from './GetAdminUserWalletDetailPageListRespVo';
import {
    GetAdminUserWalletDetailPageListRespVoFromJSON,
    GetAdminUserWalletDetailPageListRespVoFromJSONTyped,
    GetAdminUserWalletDetailPageListRespVoToJSON,
    GetAdminUserWalletDetailPageListRespVoToJSONTyped,
} from './GetAdminUserWalletDetailPageListRespVo';

/**
 * 
 * @export
 * @interface PageDataGetAdminUserWalletDetailPageListRespVo
 */
export interface PageDataGetAdminUserWalletDetailPageListRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetAdminUserWalletDetailPageListRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetAdminUserWalletDetailPageListRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetAdminUserWalletDetailPageListRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetAdminUserWalletDetailPageListRespVo>}
     * @memberof PageDataGetAdminUserWalletDetailPageListRespVo
     */
    records?: Array<GetAdminUserWalletDetailPageListRespVo>;
}

/**
 * Check if a given object implements the PageDataGetAdminUserWalletDetailPageListRespVo interface.
 */
export function instanceOfPageDataGetAdminUserWalletDetailPageListRespVo(value: object): value is PageDataGetAdminUserWalletDetailPageListRespVo {
    return true;
}

export function PageDataGetAdminUserWalletDetailPageListRespVoFromJSON(json: any): PageDataGetAdminUserWalletDetailPageListRespVo {
    return PageDataGetAdminUserWalletDetailPageListRespVoFromJSONTyped(json, false);
}

export function PageDataGetAdminUserWalletDetailPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetAdminUserWalletDetailPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetAdminUserWalletDetailPageListRespVoFromJSON)),
    };
}

export function PageDataGetAdminUserWalletDetailPageListRespVoToJSON(json: any): PageDataGetAdminUserWalletDetailPageListRespVo {
    return PageDataGetAdminUserWalletDetailPageListRespVoToJSONTyped(json, false);
}

export function PageDataGetAdminUserWalletDetailPageListRespVoToJSONTyped(value?: PageDataGetAdminUserWalletDetailPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetAdminUserWalletDetailPageListRespVoToJSON)),
    };
}

